<template>
  <svg width="28"
       height="33"
       viewBox="0 0 56 73"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M39.7014 0H1.9053C0.853023 0 0 0.853023 0 2.50828V71.6279C0 72.0772 0.853023 72.9302 1.9053 72.9302H54.0947C55.147 72.9302 56 72.0772 56 71.6279V16.9016C56 15.9952 55.8789 15.7034 55.6653 15.4886L40.5114 0.334698C40.2966 0.121116 40.0048 0 39.7014 0Z"
          fill="#E9E9E0"/>
    <path d="M40.3716 0.196289V15.6275H55.8028L40.3716 0.196289Z"
          fill="#D9D7CA"/>
    <path d="M54.0947 72.9291H1.9053C0.853023 72.9291 0 72.0761 0 71.0238V50.7896H56V71.0238C56 72.0761 55.147 72.9291 54.0947 72.9291Z"
          fill="#007D87"/>
    <path d="M17.3403 23.4997C20.4731 23.4997 23.0127 20.9601 23.0127 17.8274C23.0127 14.6946 20.4731 12.155 17.3403 12.155C14.2076 12.155 11.668 14.6946 11.668 17.8274C11.668 20.9601 14.2076 23.4997 17.3403 23.4997Z"
          fill="url(#paint0_linear_35598_1872)"/>
    <path d="M4.8623 46.1894L5.37773 45.4579L14.5408 32.243C15.0562 31.4879 15.8808 31.0513 16.7742 31.0513C17.6676 31.0513 18.4923 31.4879 19.0077 32.2312L22.5011 37.2694L32.0078 24.5973C32.5347 23.9012 33.3364 23.5 34.184 23.5C35.0316 23.5 35.8448 23.9012 36.3602 24.5973L51.9374 45.3635L52.5101 46.1304"
          fill="#00CC99"/>
    <path d="M12.104 65.0662C12.104 65.7168 12.0293 66.2688 11.88 66.7222C11.736 67.1702 11.4773 67.5115 11.104 67.7462C10.7307 67.9755 10.1973 68.0902 9.504 68.0902C9.10933 68.0902 8.728 68.0475 8.36 67.9622C7.992 67.8768 7.73867 67.8102 7.6 67.7622L7.688 66.1462C7.85333 66.1995 8.04 66.2662 8.248 66.3462C8.46133 66.4208 8.72 66.4582 9.024 66.4582C9.54667 66.4582 9.904 66.3142 10.096 66.0262C10.288 65.7382 10.384 65.2608 10.384 64.5942V56.3622H12.104V65.0662ZM14.7296 67.9302V56.3622H18.7376C19.5643 56.3622 20.303 56.5035 20.9536 56.7862C21.6096 57.0688 22.1243 57.4848 22.4976 58.0342C22.8763 58.5835 23.0656 59.2582 23.0656 60.0582C23.0656 60.8262 22.8923 61.4822 22.5456 62.0262C22.2043 62.5648 21.7243 62.9782 21.1056 63.2662C20.4923 63.5488 19.7803 63.6902 18.9696 63.6902H16.4736V67.9302H14.7296ZM16.4656 62.2902H18.9216C19.6576 62.2902 20.2576 62.0795 20.7216 61.6582C21.1856 61.2315 21.4176 60.6662 21.4176 59.9622C21.4176 59.2475 21.1776 58.7008 20.6976 58.3222C20.2176 57.9382 19.6043 57.7462 18.8576 57.7462H16.4656V62.2902ZM24.9796 67.9302V56.3622H32.4516L32.4436 57.8502H26.6996V61.3622H31.8276V62.8262H26.6916V66.4182L32.5876 66.4262V67.9302H24.9796ZM39.3008 68.0902C38.2714 68.0902 37.3834 67.8555 36.6368 67.3862C35.8901 66.9168 35.3141 66.2422 34.9088 65.3622C34.5088 64.4768 34.3088 63.4155 34.3088 62.1782C34.3088 60.9302 34.5141 59.8608 34.9248 58.9702C35.3408 58.0742 35.9301 57.3888 36.6928 56.9142C37.4554 56.4395 38.3514 56.2022 39.3808 56.2022C39.9941 56.2022 40.5621 56.3062 41.0848 56.5142C41.6128 56.7222 42.0768 57.0048 42.4768 57.3622C42.8821 57.7195 43.2021 58.1248 43.4368 58.5782C43.6714 59.0315 43.8048 59.5062 43.8368 60.0022H42.0128C41.9381 59.5915 41.7781 59.2128 41.5328 58.8662C41.2928 58.5142 40.9861 58.2315 40.6128 58.0182C40.2394 57.8048 39.8181 57.6982 39.3488 57.6982C38.7248 57.6982 38.1728 57.8528 37.6927 58.1622C37.2128 58.4715 36.8368 58.9542 36.5648 59.6102C36.2981 60.2608 36.1648 61.1035 36.1648 62.1382C36.1648 62.9435 36.2474 63.6288 36.4128 64.1942C36.5834 64.7595 36.8154 65.2155 37.1088 65.5622C37.4021 65.9088 37.7461 66.1622 38.1408 66.3222C38.5354 66.4768 38.9568 66.5542 39.4048 66.5542C39.8474 66.5542 40.2368 66.4768 40.5728 66.3222C40.9088 66.1675 41.1888 65.9675 41.4128 65.7222C41.6421 65.4768 41.8181 65.2128 41.9408 64.9302C42.0688 64.6422 42.1434 64.3648 42.1648 64.0982L42.2208 63.1622H39.5168V61.9302L44.0048 61.9462V67.9302H42.7648V66.2342C42.5621 66.5488 42.3088 66.8475 42.0048 67.1302C41.7008 67.4128 41.3274 67.6448 40.8848 67.8262C40.4421 68.0022 39.9141 68.0902 39.3008 68.0902Z"
          fill="white"/>
    <defs>
      <linearGradient id="paint0_linear_35598_1872"
                      x1="13.1477"
                      y1="21.8683"
                      x2="15.3819"
                      y2="12.0764"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#A58500"/>
        <stop offset="0.5028"
              stop-color="#FBC402"/>
        <stop offset="1"
              stop-color="#FFE9A4"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'JPEGIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
